export default {
  translation: {
    common: {
      emailOrUsername: "Електронна пошта або ім'я користувача",
      invalidEmailOrUsername: "Неправильна електронна пошта або ім'я користувача",
      invalidPassword: 'Неправильний пароль',
      noInternetConnection: 'Відсутнє підключення до Інтернету',
      pageNotFound_title: 'Сторінку не знайдено',
      password: 'Пароль',
      projectManagement: 'Управління проектами',
      serverConnectionFailed: 'Не вдалося підключитися до сервера',
      unknownError: 'Невідома помилка, спробуйте ще раз пізніше',
      useSingleSignOn: 'Використовувати одночасний вхід',
    },

    action: {
      logIn: 'Увійти',
      logInWithSSO: 'Увійти за допомогою SSO',
    },
  },
};
